import './App.css';

import React, { useState, useEffect } from 'react';
import './App.css';
import LoaderDark from '@components/loader/LoaderDark';
import Header from '@components/header/Header';
import Home from '@components/home/Home';
import About from '@components/about/About';
import Services from '@components/services/Services';
import Qualification from '@components/qualification/Qualification';
import Contact from '@components/contact/Contact';
import Footer from '@components/footer/Footer';
import ScrollUp from '@components/scrollup/ScrollUp';
import Meet from '@components/meet/Meet';
// import LoaderSpiderMan from '@components/loader/LoaderSpiderMan';
// import Loader from '@components/loader/Loader';
// import Skills from '@components/skills/Skills';
// import Portfolio from '@components/portfolio/Portfolio';
// import Certifications from '@components/certifications/Certifications';
// import Testimonials from '@components/testimonials/Testimonials';


const App = () => {

	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		// Simulate a loading delay
		setTimeout(() => {
			setIsLoading(false);
		}, 2000);
	}, []);

	return (
		<>
			{
				isLoading ? <LoaderDark /> :
					<>
						<Header />
						<main className='main'>
							<Home />
							<About />
							<Qualification />
							{/* <Skills /> */}
							<Services />
							{/* <Testimonials /> */}
							{/* <Certifications /> */}
							{/* <Portfolio /> */}
							<Meet />
							<Contact />
						</main>
						<Footer />
						<ScrollUp />
					</>
			}
		</>
	)
}

export default App;
